import { FaBell } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";
import { useTranslation } from "react-i18next";

const DropdownItemAtendimento = ({ notif, onClick }) => {
    const { t } = useTranslation(['layout']);
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = info.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaBell />}
            text="text-primary"
            titulo={t('layout:notificationItems.encounter.title')}
            descricao={
                <>
                    Paciente: <strong>{info.beneficiario_nome}</strong>
                </>
            }
            subDescricao={`${t('layout:notificationItems.label.program')}: ${info.programa_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemAtendimento;
